function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { addMonths } from 'date-fns';
import Trigger from '@cloud-sn/v-trigger';
import { formatDate, isValidArray } from '../utils';
import RangeCalendar from '../rangeCalendar.js';
import localeEN from '../locale/en_US';
import placements from './placements';
var __vue_script__ = {
  name: 'RangeDatePicker',
  components: {
    Trigger: Trigger,
    RangeCalendar: RangeCalendar
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-calendar'
    },
    pickerPrefixCls: {
      type: String,
      default: 'v-calendar-picker'
    },
    locale: {
      type: Object,
      default: function _default() {
        return localeEN;
      }
    },
    value: {
      type: Array,
      default: function _default() {
        // const date = new Date();
        // return [date, addMonths(date, 1)];
        // issue 166: 不能在default中提供默认范围，否则不好处理用户设置的默认显示时间。当然也可以在这边把用户设置的默认时间设置到默认值上，但是在属性校验阶段不一定能获取到其他属性，需要对属性定义顺序做调整
        return [];
      }
    },
    selectedValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mode: {
      type: Array,
      default: function _default() {
        return ['date', 'date'];
      }
    },
    theme: {
      type: String,
      default: 'light'
    },
    showClear: Boolean,
    isOpen: Boolean,
    format: String,
    disabled: Boolean,
    disabledDate: Function,
    disabledTime: Function,
    dateInputPlaceholder: [String, Array],
    showTime: {
      type: [Boolean, Object],
      default: false
    },
    showOk: {
      type: Boolean,
      default: function _default() {
        return !!this.showTime;
      }
    },
    showToday: {
      type: Boolean,
      default: false
    },
    ranges: {
      type: [Object, Array],
      default: undefined
    },
    placement: {
      type: String,
      default: 'bottomLeft'
    },
    transitionName: {
      type: String,
      default: ''
    },
    animation: {
      type: String,
      default: ''
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    okConfirm: {
      type: Boolean,
      default: false
    },
    controlMode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      buildinPlacements: placements,
      open: false,
      align: {// points: ['tl', 'tl'],
      },
      innerValues: this.selectedValue,
      inputValues: this.selectedValue
    };
  },
  computed: {
    clanderClasses: function clanderClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          theme = this.theme,
          isShowTime = this.isShowTime;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-time"), isShowTime), _defineProperty(_ref, "".concat(prefixCls, "-").concat(theme), true), _ref;
    },
    actions: function actions() {
      var disabled = this.disabled;
      return disabled ? [] : ['click'];
    },
    isShowTime: function isShowTime() {
      return !!this.showTime;
    },
    dateFormat: function dateFormat() {
      var format = this.format,
          isShowTime = this.isShowTime;
      return format || (isShowTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
    },
    formatValue: function formatValue() {
      var inputValues = this.inputValues,
          dateFormat = this.dateFormat;

      var _inputValues = _slicedToArray(inputValues, 2),
          start = _inputValues[0],
          end = _inputValues[1];

      return isValidArray(inputValues) ? "".concat(formatDate(start, dateFormat), "~").concat(formatDate(end, dateFormat)) : '';
    },
    isHasOkButton: function isHasOkButton() {
      var isShowTime = this.isShowTime,
          showOk = this.showOk;
      return showOk === true || showOk !== false && !!isShowTime;
    },
    isOkConfirm: function isOkConfirm() {
      var isHasOkButton = this.isHasOkButton,
          okConfirm = this.okConfirm;
      return isHasOkButton && okConfirm;
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          onPanelChange = this.onPanelChange,
          onSelect = this.onSelect,
          onCalendarChange = this.onCalendarChange,
          onQuickSelect = this.onQuickSelect,
          onOk = this.onOk;
      return _objectSpread({}, $listeners, {
        'on-panel-change': onPanelChange,
        'on-select': onSelect,
        'calendar-change': onCalendarChange,
        'on-quick-select': onQuickSelect,
        'on-ok': onOk
      });
    }
  },
  watch: {
    selectedValue: function selectedValue(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerValues = nVal;
        this.inputValues = nVal;
      }
    },
    isOpen: function isOpen(nVal, oVal) {
      if (nVal !== oVal) {
        this.setOpen(nVal);
      }
    }
  },
  created: function created() {
    var disabled = this.disabled,
        isOpen = this.isOpen,
        setOpen = this.setOpen;
    setOpen(disabled ? false : isOpen);
  },
  methods: {
    setOpen: function setOpen(flag) {
      this.open = flag;
    },
    onPanelChange: function onPanelChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['panel-change'].concat(args));
    },
    // 每次选择时间后都触发
    onCalendarChange: function onCalendarChange(values) {
      this.$emit('calendar-change', values);
    },
    onChange: function onChange(values) {
      var hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var extra = arguments.length > 2 ? arguments[2] : undefined;
      var dateFormat = this.dateFormat,
          setOpen = this.setOpen;
      this.inputValues = values;
      this.$emit('change', values, [formatDate(values[0], dateFormat), formatDate(values[1], dateFormat)], extra);

      if (hide) {
        setOpen(false);
      }
    },
    onQuickSelect: function onQuickSelect(values, range) {
      this.innerValues = values;
      this.onChange(values, true, {
        type: 'quick-select',
        content: range
      });
      this.$emit('quick-select', values, range);
    },
    onSelect: function onSelect(values, range) {
      var isOkConfirm = this.isOkConfirm,
          isHasOkButton = this.isHasOkButton,
          onChange = this.onChange;
      this.innerValues = values;

      if (!isOkConfirm) {
        onChange(values, !isHasOkButton, range);
      }
    },
    onPopupVisible: function onPopupVisible(visible) {
      if (visible) {
        this.innerValues = this.inputValues;
      }

      this.setOpen(visible);
      this.$emit('open-change', visible);
    },
    onOk: function onOk(values) {
      var setOpen = this.setOpen,
          isHasOkButton = this.isHasOkButton,
          isOkConfirm = this.isOkConfirm,
          onChange = this.onChange;
      setOpen(false);

      if (isHasOkButton) {
        this.$emit('ok', values);

        if (isOkConfirm) {
          onChange(values);
        }
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('trigger', {
    attrs: {
      "prefix-cls": _vm.pickerPrefixCls,
      "visible": _vm.open,
      "actions": _vm.actions,
      "popup-align": _vm.align,
      "popup-placement": _vm.placement,
      "builtin-placements": _vm.buildinPlacements,
      "popup-transition-name": _vm.transitionName,
      "popup-animation": _vm.animation,
      "get-popup-container": _vm.getPopupContainer,
      "destroy-popup-on-hide": ""
    },
    on: {
      "on-popup-visible-change": _vm.onPopupVisible
    }
  }, [_c('template', {
    slot: "trigger"
  }, [_vm._t("trigger")], 2), _vm._v(" "), _c('range-calendar', _vm._g({
    class: _vm.clanderClasses,
    attrs: {
      "slot": "popup",
      "prefix-cls": _vm.prefixCls,
      "value": _vm.value,
      "selected-value": _vm.innerValues,
      "format": _vm.dateFormat,
      "show-clear": _vm.showClear,
      "date-input-placeholder": _vm.dateInputPlaceholder,
      "has-time-picker": _vm.isShowTime,
      "locale": _vm.locale,
      "mode": _vm.mode,
      "show-ok": _vm.showOk,
      "show-today": _vm.showToday,
      "disabled-date": _vm.disabledDate,
      "disabled-time": _vm.disabledTime,
      "ranges": _vm.ranges,
      "show-time": _vm.showTime,
      "control-mode": _vm.controlMode
    },
    slot: "popup"
  }, _vm.bindListeners))], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "rangeDatePicker.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);